/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Origin_Exclusive_MessageInputs */

const en_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin is available exclusively in the Brave browser.`)
};

const id_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin tersedia secara eksklusif di browser Brave.`)
};

const ms_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin tersedia secara eksklusif di penyemak imbas Brave.`)
};

const ca_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin només està disponible al navegador de Brave.`)
};

const cs_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin je k dispozici výhradně v prohlížeči Brave.`)
};

const da_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin er udelukkende tilgængelig i Brave-browseren.`)
};

const de_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin ist ausschließlich im Brave Browser verfügbar.`)
};

const et_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin on saadaval ainult Brave'i brauseris.`)
};

const es_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin está disponible exclusivamente en el navegador de Brave.`)
};

const fr_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin est disponible exclusivement dans le navigateur Brave.`)
};

const hr_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin je dostupan isključivo u pregledniku Brave.`)
};

const it_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin è disponibile esclusivamente nel browser Brave.`)
};

const lv_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin ir pieejams tikai Brave pārlūkā.`)
};

const lt_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`„Origin“ prieinamas tik „Brave“ naršyklėje.`)
};

const hu_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az Origin kizárólag a Brave böngészőben érhető el.`)
};

const nl_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin is exclusief beschikbaar in de Brave-browser.`)
};

const nb_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin er kun tilgjengelig i Braves nettleser.`)
};

const pl_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subskrypcja Origin jest dostępna wyłącznie w przeglądarce Brave.`)
};

const pt_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Origin está disponível exclusivamente no navegador Brave.`)
};

const ro_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin este disponibil exclusiv în browserul Brave.`)
};

const sk_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin je k dispozícii výlučne v prehliadači Brave.`)
};

const sl_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin je na voljo izključno v brskalniku Brave.`)
};

const fi_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin on saatavilla ainoastaan Brave-selaimessa.`)
};

const sv_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin är endast tillgänglig i Brave-webbläsaren.`)
};

const vi_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin chỉ có trên trình duyệt Brave.`)
};

const tr_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin yalnızca Brave tarayıcısında kullanılabilir.`)
};

const el_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Το Origin είναι διαθέσιμο αποκλειστικά στο πρόγραμμα περιήγησης Brave.`)
};

const bg_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin се предлага изключително в браузъра Brave.`)
};

const ru_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin доступен исключительно в браузере Brave.`)
};

const sr_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin је доступан искључиво у Brave прегледачу.`)
};

const uk_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Функція Origin доступна виключно у браузері Brave.`)
};

const ka_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin ხელმისაწვდომია მხოლოდ Brave ბრაუზერში.`)
};

const hi_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओरिजिन केवल ब्रेव ब्राउज़र में उपलब्ध है।`)
};

const th_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin มีให้บริการเฉพาะในเบราว์เซอร์ Brave เท่านั้น`)
};

const ko_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin은 Brave 브라우저에서만 사용할 수 있습니다.`)
};

const zh_tw_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin 僅限於 Brave 瀏覽器中使用。`)
};

const ja_origin_exclusive_message = /** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OriginはBraveブラウザでのみ利用できます。`)
};

/** @type {(inputs: Origin_Exclusive_MessageInputs) => LocalizedString} */
const zh_origin_exclusive_message = en_origin_exclusive_message;

/**
* | output |
* | --- |
* | "Origin is available exclusively in the Brave browser." |
*
* @param {Origin_Exclusive_MessageInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const origin_exclusive_message = /** @type {((inputs?: Origin_Exclusive_MessageInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Origin_Exclusive_MessageInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_origin_exclusive_message(inputs)
	if (locale === "ms") return ms_origin_exclusive_message(inputs)
	if (locale === "ca") return ca_origin_exclusive_message(inputs)
	if (locale === "cs") return cs_origin_exclusive_message(inputs)
	if (locale === "da") return da_origin_exclusive_message(inputs)
	if (locale === "de") return de_origin_exclusive_message(inputs)
	if (locale === "et") return et_origin_exclusive_message(inputs)
	if (locale === "es") return es_origin_exclusive_message(inputs)
	if (locale === "fr") return fr_origin_exclusive_message(inputs)
	if (locale === "hr") return hr_origin_exclusive_message(inputs)
	if (locale === "it") return it_origin_exclusive_message(inputs)
	if (locale === "lv") return lv_origin_exclusive_message(inputs)
	if (locale === "lt") return lt_origin_exclusive_message(inputs)
	if (locale === "hu") return hu_origin_exclusive_message(inputs)
	if (locale === "nl") return nl_origin_exclusive_message(inputs)
	if (locale === "nb") return nb_origin_exclusive_message(inputs)
	if (locale === "pl") return pl_origin_exclusive_message(inputs)
	if (locale === "pt") return pt_origin_exclusive_message(inputs)
	if (locale === "ro") return ro_origin_exclusive_message(inputs)
	if (locale === "sk") return sk_origin_exclusive_message(inputs)
	if (locale === "sl") return sl_origin_exclusive_message(inputs)
	if (locale === "fi") return fi_origin_exclusive_message(inputs)
	if (locale === "sv") return sv_origin_exclusive_message(inputs)
	if (locale === "vi") return vi_origin_exclusive_message(inputs)
	if (locale === "tr") return tr_origin_exclusive_message(inputs)
	if (locale === "el") return el_origin_exclusive_message(inputs)
	if (locale === "bg") return bg_origin_exclusive_message(inputs)
	if (locale === "ru") return ru_origin_exclusive_message(inputs)
	if (locale === "sr") return sr_origin_exclusive_message(inputs)
	if (locale === "uk") return uk_origin_exclusive_message(inputs)
	if (locale === "ka") return ka_origin_exclusive_message(inputs)
	if (locale === "hi") return hi_origin_exclusive_message(inputs)
	if (locale === "th") return th_origin_exclusive_message(inputs)
	if (locale === "ko") return ko_origin_exclusive_message(inputs)
	if (locale === "zh") return zh_origin_exclusive_message(inputs)
	if (locale === "zh-tw") return zh_tw_origin_exclusive_message(inputs)
	if (locale === "ja") return ja_origin_exclusive_message(inputs)
	return en_origin_exclusive_message(inputs)
});